import type { Composer } from "vue-i18n";

//* 将物种id转物种名称
export default (species: string | number, mode: "simple" | "arabia" | "default" = "default", i18n?: Composer) => {
    i18n = i18n || useI18n();
    const contrast = {
        default: { 9606: i18n.t("Human"), 10090: i18n.t("Mouse"), 10116: i18n.t("Rat") },
        simple: { 9606: i18n.t("Hsa"), 10090: i18n.t("Mmu"), 10116: i18n.t("Rat") },
        arabia: { 9606: i18n.t("Human", 2), 10090: i18n.t("Mouse", 2), 10116: i18n.t("Rat", 2) },
    };

    switch (species?.toString()) {
        case "9606":
            return contrast[mode][9606];
        case "10090":
            return contrast[mode][10090];
        case "10116":
            return contrast[mode][10116];
        default:
            return "";
    }
};
